// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + ".61f3bc6d556631b45914ca0229e6b7b2.js";
};